import { loaderById, loaderGrid } from "../../middleware/route-provider.js";

import MNGPage from "./index.js";
import CustomerModulesModifyPage from "./menu/customer/CustomerModulesModify.js";
import CustomerModulesPage from "./menu/customer/index.js";
import MenuPage from "./menu/index.js";
import ModuleListModifyPage from "./menu/module-list/ModuleListModify.js";
import ModuleListPage from "./menu/module-list/index.js";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  path: "MNG",
  children: [
    {
      path: "",
      element: <MNGPage />,
    },
    {
      path: "Menu",
      element: <MenuPage />,
    },
    {
      path: "Menu/ModuleList",
      element: <ModuleListPage />,
      loader: async () => {
        const result = await loaderGrid({
          url: "MNG/Menu/ModuleList",
        });
        return result;
      },
    },
    {
      path: "Menu/ModuleList/:id",
      element: <ModuleListModifyPage />,
      loader: async ({ params, request }) => {
        const url = new URL(request.url);
        const searchTerm = url.searchParams.get("treeId");
        const projectId = url.searchParams.get("projectId");

        const result = await loaderById({
          params,
          initValue: {
            tree: {
              treeId: searchTerm
                ? searchTerm === "root"
                  ? 0
                  : parseInt(searchTerm)
                : 0,
              title: "",
              projectId: projectId ?? 1,
              description: "",
              priority: "",
              price: 0,
            },
          },
          url: "MNG/Menu/ModuleList",
        });

        // if (result?.tree?.imageUrl && result.baseUrl) {
        //   result.tree.imageUrl = result.baseUrl + result.tree.imageUrl;
        // }
        return result;
      },
    },
    {
      path: "Customer/CustomerModules",
      element: <CustomerModulesPage />,
      loader: async () =>
        await loaderGrid({
          url: "MNG/Customer/CustomerModules",
        }),
    },
    {
      path: "Customer/CustomerModules/:id",
      element: <CustomerModulesModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            pmsCustomer: {
              firstName: "",
            },
          },
          url: "MNG/Customer/CustomerModules",
        });
      },
    },
  ],
};
